
export const BROWSER_TYPE = {
    CHROME: "CHROME",
    IE: "MICROSOFT INTERNET EXPLORER",
    EDGE: "MICROSOFT EDGE",
    OPERA: "OPERA",
    FIREFOX: "FIREFOX",
    SAFARI: "SAFARI",
    UC: "UC",
};

export const PLAYER_TYPE = {
    BITMOVIN: "BITMOVIN",
    SILVERLIGHT: "SILVERLIGHT",
};

export const OS = {
    WINDOWS: "WINDOWS",
    LINUX: "LINUX",
    IOS: "IOS", // check mac or ios
    VERSION: "VERSION",
};